import { DynamicValue, Element } from '@fulcrumapp/fulcrum-core';

function getChecklistCompletionText(checklistValue: DynamicValue) {
  if (checklistValue.isEmpty) {
    return '';
  }

  const { elements } = checklistValue.items[0];
  const { values } = checklistValue.items[0];
  const totalItemCount = elements.length;
  const completedItemCount = elements.reduce((total: number, element: Element) => {
    const value = values.get(element.key);
    if (value && !value.isEmpty) {
      total += 1;
    }
    return total;
  }, 0);

  return `${completedItemCount} of ${totalItemCount} items completed`;
}

export {
  getChecklistCompletionText,
};
